import { defineModule } from '../types.js';
export default defineModule({
    id: 'adherents',
    nom: 'Adhérents',
    description: 'Effectifs d’adhérents, cotisations et rythme d’appel.',
    famille: 'adherents',
    dependances: [],
    activableParDefaut: true,
    desactivable: true,
    routesApi: [],
    droits: {
        'adherents.consulter': { description: 'Consulter les adhérents et les cotisations', niveau: 'lecture' },
    },
    navigation: [
        { cle: 'adherents', libelle: 'Adhérents', picto: '◍', groupe: 'Pilotage', ordre: 80, droit: 'adherents.consulter' },
    ],
});
//# sourceMappingURL=adherents.js.map